import { formatDate } from 'coreOld/utils';
import { ImportType } from 'corporate/enums';

import {
  hiddenCostPillList,
  hiddenPricingPillList,
  partAttributesPills,
  pillList,
  vendorCostPills,
} from './constants';

export const getRecognizedHeaders = (records, recognizedHeaders) => {
  const reqHeaders = records?.[0]?.map((item, idx) => {
    const headers = Object.entries(recognizedHeaders)
      .map((header: any) => {
        if (header[1].col === idx) {
          return {
            id: header[0],
            columnHeader: item,
            name: item,
            index: idx,
          };
        }
      })
      .filter((item) => Boolean(item));

    return headers;
  });

  return reqHeaders?.flat();
};

export const getPills = (pricingCheckbox: boolean, quantityCheckbox: boolean, headers) => {
  if (pricingCheckbox) {
    return [...headers, ...hiddenPricingPillList];
  }

  if (quantityCheckbox) {
    return [...headers, ...hiddenCostPillList];
  }

  return headers;
};

export const getQuantityHeaders = (quantityPills, headers) => {
  return quantityPills.map((item) => {
    const index = headers?.findIndex((el) => item.name.includes(el));

    return {
      ...item,
      columnHeader: item.name,
      index,
    };
  });
};

export const getOptions = (data, addNewHeader?) => {
  const { manufacturer, costStartDate, costEndDate, mergeDuplicates } = data;

  return {
    costStartDate: formatDate(costStartDate),
    costEndDate: formatDate(costEndDate),
    manufacturerId: manufacturer?.id,
    manufacturerName: manufacturer?.name,
    headerRowIndex: addNewHeader ? -1 : 0,
    mergeDuplicates,
  };
};

export const getPreviewSavePartsData = (data, pills, addNewHeader) => {
  const columnIndexes = pills.reduce((obj, field) => {
    return { ...obj, [field.id]: field.index };
  }, {});

  return {
    partImport: data.partImport,
    headerRow: 0,
    headerCols: columnIndexes,
    options: getOptions(data, addNewHeader),
  };
};

export const getImportHeaders = (type: ImportType) => {
  switch (type) {
    case ImportType.PARTS_COSTS:
      return pillList;
    case ImportType.VENDOR_COST:
      return vendorCostPills;
    case ImportType.PART_ATTRIBUTES:
      return partAttributesPills;
    default:
      return [];
  }
};
